module.exports = __webpack_public_path__ + "img/info.b85d5004.svg";